var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.669,
    height: 21.682,
    viewBox: "0 0 16.669 21.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.538,
    y1: -0.387,
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1399c1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    "data-name": "Path (2)",
    d: "M7.676,20.052a4.493,4.493,0,0,1-5.584.66l-.754-.471a1.5,1.5,0,0,1-.476-2.064L2.846,15a1.5,1.5,0,0,1,2.064-.476,1.5,1.5,0,0,0,2.063-.476l3.175-5.081a1.5,1.5,0,0,0-.477-2.064A1.5,1.5,0,0,1,9.2,4.843l1.983-3.177a1.5,1.5,0,0,1,2.064-.477L14,1.66a4.493,4.493,0,0,1,1.855,5.307l0,.011A40.542,40.542,0,0,1,7.684,20.044Z",
    transform: "translate(-0.031 -0.358)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPhone);
export default __webpack_public_path__ + "static/media/bannerPhone.ba5ef6cd49057f05a2657214817179c4.svg";
export { ForwardRef as ReactComponent };